import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';

export default function PaymentFailPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const error = searchParams.get('error');
    
    console.log('❌ Ödeme başarısız:', error);
    
    // LocalStorage'ı temizle
    localStorage.removeItem('pendingOrder');
    
    toast.error(error || 'Ödeme başarısız oldu');

    setTimeout(() => {
      navigate('/cart');
    }, 3000);
  }, []);

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <div style={{ fontSize: '64px' }}>❌</div>
      <h2>Ödeme Başarısız</h2>
      <p>Sepete geri yönlendiriliyorsunuz...</p>
    </div>
  );
}